import React, {useState} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";

interface ConfiguationNameUpdateDialogProps {
  open: boolean;
  initialName: string;
  onClose: () => void;
  onRenameAll: (name: string) => void;
}

const ConfigurationEditNamesDialog: React.FC<ConfiguationNameUpdateDialogProps> = ({
  open,
  initialName,
  onClose,
  onRenameAll,
}) => {
  const [name, setName] = useState<string>(initialName);

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={onClose}>
      <DialogTitle>Renaming Configurations</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will rename the configuration, and its history.
        </DialogContentText>
        <TextField
          fullWidth
          label="name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={name === initialName || name.length === 0}
          onClick={() => onRenameAll(name)}
        >
          Rename All
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigurationEditNamesDialog;
